import { createAsyncThunk } from '@reduxjs/toolkit';
import { ConversationsAPI, SettingsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { IConversationDetails } from '@/models/conversation.model';
import { IGetSettingsDTO, IGetSettingsResponse } from '@/models/settings.model';
import { SLICE_NAME } from './models';

export const getConversationById = createAsyncThunk<
  IConversationDetails,
  { id: string },
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getConversationById`,
  async (params) => {
    const response = await ConversationsAPI.getConversationById(params);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getConversationChannelTheme = createAsyncThunk<
  IGetSettingsResponse,
  IGetSettingsDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/getConversationChannelTheme`,
  async (params) => {
    const response = await SettingsAPI.getSettings(params);
    return response.data;
  },
  { serializeError: formatApiError },
);
